export enum ESortOrder {
  DESC = 'Desc',
  ASC = 'Asc',
};

export enum EStatus {
  INITIATED = 'INITIATED',
  PROGRESS = 'PROGRESS',
  SENT = 'SENT',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
};

export enum EDirection {
  OUTWARD = 'Outward',
  INWARD = 'Inward',
  TRANSFER = 'Transfer',
  FX = 'fx',
};

export enum EBankStatus {
  ENABLED = 'Enabled',
  DISABLED = 'Disabled',
};

export enum EActive {
  DISABLED = 'N',
  ACTIVE = 'Y',
}